function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import * as React from "react";
var SvgPlans4 = function SvgPlans4(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 105 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M85.1987 42.6304H69.211H67.8787V68.6634H87.8633V45.295C87.8633 43.8234 86.6703 42.6304 85.1987 42.6304Z",
    fill: "url(#paint0_linear_10248_64185)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.69 34.2271H42.6777H44.01V68.6632H24.0254V36.8917C24.0254 35.42 25.2184 34.2271 26.69 34.2271Z",
    fill: "url(#paint1_linear_10248_64185)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6777 69.9958V19.3682C42.6777 18.6615 42.9585 17.9838 43.4582 17.4841C43.9579 16.9843 44.6356 16.7036 45.3423 16.7036H66.6592C67.3659 16.7036 68.0437 16.9843 68.5434 17.4841C69.0431 17.9838 69.3239 18.6615 69.3239 19.3682V69.9958",
    fill: "url(#paint2_linear_10248_64185)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.3359 34.0232L57.3329 32.6909V46.014",
    stroke: "white",
    strokeWidth: 2.27431,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_10248_64185)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.6973 69.9956H93.3064",
    stroke: "#2C4BD3",
    strokeWidth: 5.32922,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_10248_64185",
    x: 0.454212,
    y: 59.7121,
    width: 104.273,
    height: 29.6642,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -3.41146,
    dy: 4.54861
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.08377
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.360628 0 0 0 0 0.468474 0 0 0 0 1 0 0 0 0.61 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10248_64185"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_10248_64185",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10248_64185",
    x1: 74.3898,
    y1: 41.6298,
    x2: 95.1533,
    y2: 58.0524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F5EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#18459D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10248_64185",
    x1: 37.4989,
    y1: 32.9034,
    x2: 12.6354,
    y2: 47.7701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F5EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#18459D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_10248_64185",
    x1: 60.6424,
    y1: 14.6552,
    x2: 25.0772,
    y2: 32.9769,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F5EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#18459D"
  }))));
};
export default SvgPlans4;